const AVATAR_COLORS = [
  '#d97706',
  '#0f766e',
  '#2563eb',
  '#7c3aed',
  '#be123c',
  '#15803d',
  '#b45309',
  '#0369a1',
];

export default {
  name: 'PublicPlayerAvatar',
  props: {
    name: { type: String, default: '' },
    avatarUrl: { type: String, default: null },
    seed: { type: String, default: '' },
  },
  computed: {
    initials() {
      const parts = String(this.name || '')
        .trim()
        .split(/\s+/)
        .filter(Boolean);

      if (!parts.length) return '?';
      if (parts.length === 1) return parts[0].slice(0, 1).toUpperCase();

      return `${parts[0].slice(0, 1)}${parts[1].slice(0, 1)}`.toUpperCase();
    },

    avatarStyle() {
      if (this.avatarUrl) return {};

      const key = this.seed || this.name || '?';
      const index = this.getStableColorIndex(key);

      return {
        '--public-player-avatar-bg': AVATAR_COLORS[index],
      };
    },
  },
  methods: {
    getStableColorIndex(value) {
      let hash = 0;
      const source = String(value);

      for (let index = 0; index < source.length; index += 1) {
        hash = ((hash << 5) - hash) + source.charCodeAt(index);
        hash |= 0;
      }

      return Math.abs(hash) % AVATAR_COLORS.length;
    },
  },
};
